// extracted by mini-css-extract-plugin
module.exports = {"basecolor":"#109cf1"};